import React from 'react';
import PropTypes from 'prop-types';
import NavActions from '../../actions';
import {getDataAttribute} from 'epic-common/src/browser';

export default class UserIcon extends React.PureComponent {
    static propTypes = {
        isLoggedIn: PropTypes.bool,
        signInLinks: PropTypes.array,
        mobileUserActive: PropTypes.bool,
        displayName: PropTypes.string
    };

    static contextTypes = {
        messages: PropTypes.object,
        isMobile: PropTypes.bool,
        globalLinkOnClick: PropTypes.func
    };


    signInonClick = (e) => {
        const index = getDataAttribute(e.currentTarget, 'index');
        const signInLink = this.props.signInLinks[index];
        const href = signInLink.href;

        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            if (signInLink && signInLink.onClick && typeof signInLink.onClick === 'function') {
                signInLink.onClick(e);
            }
        }

        NavActions.closeMobileTablet.defer();

        setTimeout(this.showSignIn, 1);
    };

    reset() {
        //Reset all other clickable items
        NavActions.tabletNavActive(false);
        NavActions.mobileLocaleActive(false);
        NavActions.mobileActiveLinkIndex(null);
        NavActions.searchActive(false);
    }

    open() {
        if (!this.props.mobileUserActive) {
            NavActions.mobileUserActive(true);
            NavActions.mobileNavActiveLinks(false);
        } else {
            NavActions.mobileUserActive(false);
            NavActions.mobileNavActiveLinks(true);
        }
    }

    showSignIn = () => {
        if (!this.props.signInLinks || !this.context.isMobile) {
            return;
        }

        //if there is only one sign in option just execture that onClick otherwise show a menu
        const signInLinks = this.props.signInLinks.asMutable ? this.props.signInLinks.asMutable() : this.props.signInLinks || [];
        const dropdown = signInLinks.length > 1;

        if (dropdown) {
            this.open();
            this.reset();
        }
    };

    showSignedIn = (e) => {
        e.preventDefault();

        if (!this.context.isMobile) {
            return;
        }

        this.open();
        this.reset();
    };

    render() {
        let user = <div />;

        if (this.context.isMobile) {
            user = (
                <a>
                    <i className="eg-header-icon-user" />
                    <span className="sign-text item-label display-name text-color">{this.props.displayName}</span>
                </a>
            );
        }

        if (this.props.isLoggedIn) {
            user = (
                <a
                    role="menuitem"
                    tabIndex="-1"
                    className="is-logged-in text-color-hover"
                    onClick={this.showSignedIn}>
                    {this.props.mobileUserActive ? '' : <i className="eg-header-icon-user" />}
                    {this.props.mobileUserActive ? '' : <span className="sign-text item-label display-name text-color">{this.props.displayName}</span>}
                </a>
            );
        } else {
            const dropdown = this.props.signInLinks && this.props.signInLinks.length > 1;
            if (dropdown) {
                user = (
                    <a role="menuitem" tabIndex="0" className="not-logged-in text-color-hover" onClick={this.showSignedIn}>
                        {this.props.mobileUserActive ? '' : <i className="eg-header-icon-user" />}
                        {this.props.mobileUserActive ? '' :
                            <span className="sign-text item-label display-name text-color">
                                {this.context.messages.sign_in}
                            </span>
                        }
                    </a>
                );
            } else if (this.context.isMobile) {
                const signInLink = this.props.signInLinks ? this.props.signInLinks[0] : null;
                if (signInLink) {
                    user = (
                        <a
                            className="not-logged-in text-color-hover"
                            href={signInLink.href || '#'}
                            data-index={0}
                            onClick={this.signInonClick}
                            title={this.context.messages.sign_in}>
                            <i className="eg-header-icon-user" />
                            <span className="sign-text item-label display-name text-color">
                                {this.context.messages.sign_in}
                            </span>
                        </a>
                    );
                }
            }
        }

        return (
            user
        );
    }
}
